import React from 'react'
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createJobAsync, editJobAsync } from '../features/jobs/jobSlice';
import { useNavigate, useParams } from 'react-router-dom';
export default function AddJob({ isEditing }) {

    const [jobTitle, setJobTitle] = useState('');
    const [jobType, setJobType] = useState('');
    const [jobSalary, setJobSalary] = useState('');
    const [jobDeadline, setJobDeadline] = useState('');

    const buttonText = isEditing ? "Save Changes" : "Add Job";
    const pageTitle = isEditing ? "Edit Job" : "Add Job";
    const { jobId } = useParams();
    console.log(jobId);
    const job = useSelector((state) => state.jobs.jobs.find((job) => job.id === parseInt(jobId)));
    console.log(job);
    useEffect(() => {
        if (isEditing) {
            setJobTitle(job.title);
            setJobType(job.type);
            setJobSalary(job.salary);
            setJobDeadline(job.deadline);
        } else {
            setJobTitle('');
            setJobSalary('');
            setJobDeadline('');
            setJobType('');

        }
    }, [isEditing, jobId]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleSubmit = (e) => {
        e.preventDefault();
        const jobData = {
            title: jobTitle,
            type: jobType,
            salary: jobSalary,
            deadline: jobDeadline
        };
        if (isEditing) {
            dispatch(editJobAsync({ id: jobId, newData: jobData }));
        } else {
            dispatch(createJobAsync(jobData));
        }
        navigate('/');
    }

    return (<main class="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <h1 class="mb-10 text-center lws-section-title">{pageTitle}</h1>

        <div class="max-w-3xl mx-auto">
            <form class="space-y-6" onSubmit={handleSubmit}>
                <div class="fieldContainer">
                    <label for="lws-JobTitle" class="text-sm font-medium text-slate-300">Job Title</label>
                    <select id="lws-JobTitle" name="lwsJobTitle" required onChange={(e) => setJobTitle(e.target.value)} value={jobTitle}>
                        <option value="" hidden selected>Select Job</option>
                        <option>Software Engineer</option>
                        <option>Software Developer</option>
                        <option>Full Stack Developer</option>
                        <option>MERN Stack Developer</option>
                        <option>DevOps Engineer</option>
                        <option>QA Engineer</option>
                        <option>Product Manager</option>
                        <option>Social Media Manager</option>
                        <option>Senior Executive</option>
                        <option>Junior Executive</option>
                        <option>Android App Developer</option>
                        <option>IOS App Developer</option>
                        <option>Frontend Developer</option>
                        <option>Frontend Engineer</option>
                    </select>
                </div>

                <div class="fieldContainer">
                    <label for="lws-JobType">Job Type</label>
                    <select id="lws-JobType" name="lwsJobType" required onChange={(e) => setJobType(e.target.value)} value={jobType}>
                        <option value="" hidden selected>Select Job Type</option>
                        <option>Full Time</option>
                        <option>Internship</option>
                        <option>Remote</option>
                    </select>
                </div>

                <div class="fieldContainer">
                    <label for="lws-JobSalary">Salary</label>
                    <div class="flex border rounded-md shadow-sm border-slate-600">
                        <span class="input-tag">BDT</span>
                        <input type="number" name="lwsJobSalary" id="lws-JobSalary" required class="!rounded-l-none !border-0"
                            placeholder="20,00,000" onChange={(e) => setJobSalary(e.target.value)} value={jobSalary} />
                    </div>
                </div>

                <div class="fieldContainer">
                    <label for="lws-JobDeadline">Deadline</label>
                    <input type="date" name="lwsJobDeadline" id="lws-JobDeadline" required onChange={(e) => setJobDeadline(e.target.value)} value={jobDeadline} />
                </div>

                <div class="text-right">
                    <button type="submit" id="lws-submit" class="cursor-pointer btn btn-primary w-fit">
                        {buttonText}
                    </button>
                </div>
            </form>
        </div>
    </main>
    )
}
